import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  ViewChild,
  ElementRef,
  OnDestroy
} from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { AppState } from '@eview/core/store/states/app.state';
import { Store } from '@ngrx/store';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription, fromEvent, throwError, Observable } from 'rxjs';
import { map, catchError, debounceTime } from 'rxjs/operators';
import { PostService } from '@eview/core/domain/post/post.service';
import { FormHelpers } from '@eview/core/domain/form/form.helpers';
import {
  FormAttributes,
  FormAttributeType
} from '@eview/core/domain/form/form-attribute';
import { selectFormAttributes } from '@eview/core/store/selectors/form-attributes.selector';

@Component({
  selector: 'eview-post-search',
  styleUrls: ['post-search.component.scss'],
  templateUrl: 'post-search.component.html'
})
export class PostSearchComponent implements OnInit, OnDestroy {
  @Input() openModal: Observable<boolean>;
  @Input() isAllReports: boolean;
  @Input() postId: number;
  @Input() postType: string;
  @Output() onApplyClick: EventEmitter<object> = new EventEmitter();
  @Output() onCancelClick: EventEmitter<boolean> = new EventEmitter();

  subs: Subscription;
  applyDisabled = true;
  isErrorReport: boolean;
  mainPost: any;
  formAttributes: FormAttributes;
  postTitleLabel: string;
  @ViewChild('contentPostLink', { static: false }) mymodal: ElementRef;

  constructor(
    private store: Store<AppState>,
    private postService: PostService,
    private modalService: NgbModal
  ) {
    this.subs = new Subscription();
  }

  ngOnInit() {
    if (this.openModal) {
      this.openModal.subscribe(flag => {
        if (flag) {
          this.onLinkPostClicked(true);
        }
      });
    }
    this.subs.add(
      this.store.select(selectFormAttributes).subscribe(formAttributes => {
        this.formAttributes = FormHelpers.SortFormAttributes(formAttributes);
        this.postTitleLabel = '';
        for (const attribute of this.formAttributes?.results || []) {
          if (attribute.type === FormAttributeType.Title) {
            this.postTitleLabel = attribute.label;
            break;
          }
        }
      })
    );
  }

  onPostSearch(searchPostId) {
    if (searchPostId > 0) {
      this.subs.add(
        this.postService
          .read(searchPostId)
          .pipe(
            debounceTime(1000),
            catchError(err => {
              if (err instanceof HttpErrorResponse) {
                this.onClearClick();
                this.isErrorReport = true;
                return throwError(err);
              }
            })
          )
          .subscribe(post => {
            this.mainPost = post;
            if (
              this.postType !== this.mainPost.type ||
              this.postId === this.mainPost.id
            ) {
              this.onClearClick();
              this.isErrorReport = true;
            } else {
              this.applyDisabled = false;
              if (!this.isAllReports) {
                const hasParent = !!(
                  this.mainPost?.parent?.id || this.mainPost?.parent_id
                );
                this.applyDisabled = this.isErrorReport = hasParent;
              }
            }
          })
      );
    }
  }

  initializePostSearch() {
    const searchByPostId: Element = document.getElementById('search-by-postid');
    const keyup$ = fromEvent(searchByPostId, 'keyup');
    keyup$
      .pipe(
        map((e: any) => {
          if (e !== '') {
            this.isErrorReport = false;
          }
          return e.currentTarget.value as string;
        }),
        debounceTime(500)
      )
      .subscribe(post => {
        this.onPostSearch(post);
      });
  }

  onLinkPostClicked(flag) {
    if (flag) {
      this.modalService.open(this.mymodal, { centered: true });
      this.initializePostSearch();
    }
  }

  onClearClick() {
    this.applyDisabled = true;
    this.isErrorReport = false;
    const inputValue = <HTMLInputElement>(
      document.getElementById('search-by-postid')
    );
    if (inputValue) {
      inputValue.value = '';
    }
    if (this.mainPost) {
      this.mainPost.title = '';
    }
  }

  onCloseClick() {
    this.isErrorReport = false;
    this.onCancelClick.emit(false);
  }

  onSubmitClick() {
    this.onApplyClick.emit({ post: this.mainPost, flag: true });
    this.modalService.dismissAll();
    this.onClearClick();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
